import React from "react";
import API from "../../base/API";
import { translate } from "../../base/Translation";
import SorTable from "../../base/SorTable";
import moment from "moment";

export default class TestLog extends React.Component {
    constructor(props) {
        super(props);

        this.api = new API({
            fetch_by_entity: "/notification/fetch/by/entity/:entity/:entity_id?limit_from=0&limit_max=99999"
        });

        this.state = {
            notifications: [],
            tableData: [],
            tableColumns: [
                { name: "user", display: translate("Používateľ"), sort: true, width: 20 },
                { name: "action", display: translate("Akcia"), sort: true, width: 20 },
                { name: "content", display: translate("Obsah"), sort: true, width: 50 },
                { name: "date", display: translate("Dátum"), sort: true, width: 10 },
            ]
        };
    }

    handleReloadLog() {
        this.fetchData();
    }

    componentDidUpdate(nextProps) {
        if (nextProps.test !== this.props.test) {
            this.fetchData();
        }
    }

    fetchData() {
        this.api.request({
            cache: false,
            route: "fetch_by_entity",
            params: { entity: "Test", entity_id: this.props.test.id },
            success: (response) => {
                let tableData = this.convertDataForTable(response);
                this.setState({ notifications: response, tableData });
            }
        });
    }

    componentDidMount() {
        this.fetchData();
        window.addEventListener("reloadLog", this.handleReloadLog.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("reloadLog", this.handleReloadLog.bind(this));
    }


    convertDataForTable(data) {
        return data.map(function (notification) {
            let data = {};
            data.user = notification.user.name;
            data.content = notification.content;
            data.action = notification.action;
            data.date = moment(notification.created.date).format("D.M.Y H:m:s");
            return data;
        });
    }

    render() {
        return (
            <SorTable columns={this.state.tableColumns} data={this.state.tableData} headers={true} searchBy="action" />
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/test/parts/TestLog.jsx